module.exports = __webpack_public_path__ + "static/media/logo.75cad6d1.svg";